// Analysis function to understand what's available
const analyzeApp = () => {
  console.log("ANALYZING APP STATE:");
  
  if (typeof window !== 'undefined') {
    // Check what functions are available
    const availableFunctions = {
      showAgentComponent: typeof (window as any).showAgentComponent,
      setAgentState: typeof (window as any).setAgentState,
      toggleNextView: typeof (window as any).toggleNextView,
      toggleAgentStatus: typeof (window as any).toggleAgentStatus
    };
    
    console.log("Available functions:", availableFunctions);
    
    // Test each function
    if ((window as any).showAgentComponent) {
      console.log("Testing showAgentComponent...");
      try {
        const result = (window as any).showAgentComponent('AgentOnline');
        console.log("showAgentComponent result:", result);
      } catch (error) {
        console.error("showAgentComponent error:", error);
      }
    }
    
    if ((window as any).toggleNextView) {
      console.log("Testing toggleNextView...");
      try {
        const result = (window as any).toggleNextView();
        console.log("toggleNextView result:", result);
      } catch (error) {
        console.error("toggleNextView error:", error);
      }
    }
  } else {
    console.log("Window object not available");
  }
}

// Simple toggleAgentOnline function
const toggleAgentOnline = () => {
  console.log("toggleAgentOnline called");
  
  if (typeof window !== 'undefined' && (window as any).toggleNextView) {
    const result = (window as any).toggleNextView();
    console.log("toggleNextView returned:", result);
    return result === null ? "Returned to normal app view" : `Switched to ${result}`;
  }
  
  return "No toggleNextView available";
}

// Make functions available globally
if (typeof window !== 'undefined') {
  (window as any).toggleAgentOnline = toggleAgentOnline;
  (window as any).analyzeApp = analyzeApp;
}

export { toggleAgentOnline, analyzeApp };

export const agentUtils = {
  toggleAgentOnline,
  analyzeApp
}; 